import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
// From lib
import { Formik, Form } from 'formik';
import { verificationCodeValidation } from '../../utils/validationRules';
// Components
import './VerifyPhoneNumber.css';
// Actions
import { addContactInfo, verifiedNumberSuccess, verifiedNumberError } from '../../actions/actionCreators';
// Intl
import {
    FormattedMessage,
    injectIntl
} from "react-intl";

class VerifyPhoneNumber extends React.Component {

    componentDidMount() {
        let phoneNumber = this.props.inquiryData.contact.phone;
        let countryCode = this.props.inquiryData.contact.countryCode;
        let verified = this.props.inquiryData.verified;
        let lang = this.props.lang;
        let recaptchaToken = this.props.recaptchaToken;

        if (verified === false) {
            let headers = new Headers({
                'Content-Type': 'application/json',
                'Google-Recaptcha-Responsetoken': recaptchaToken,
                'Google-Recaptcha-Action': 'submit_contact_info'
            });
            fetch(`https://otg-privacy-api.azurewebsites.net/api/security/code/request?phone=${countryCode}${phoneNumber}&languageCode=${lang}`, {
                method: 'GET',
                headers
            }).then(response => {
                if (response.ok)
                    setTimeout(() => {}, 1000);
            }).catch((e) => {
                console.log('error:', e);
            })
        }
    }

    sendSms() {
        let phoneNumber = this.props.inquiryData.contact.phone;
        let countryCode = this.props.inquiryData.contact.countryCode;
        let lang = this.props.lang;

        grecaptcha.enterprise.ready(async () => {
            grecaptcha.enterprise.execute('6LfPbN8nAAAAAPWdxbFFCK4fUCscG2q1nEXxTm1p', {action: 'resend_code'})
            .then(token => {
                let headers = new Headers({
                    'Content-Type': 'application/json',
                    'Google-Recaptcha-Responsetoken': token,
                    'Google-Recaptcha-Action': 'resend_code'
                });
                fetch(`https://otg-privacy-api.azurewebsites.net/api/security/code/request?phone=${countryCode}${phoneNumber}&languageCode=${lang}`, {
                    method: 'GET',
                    headers
                }).then(response => {
                    if (response.ok)
                        setTimeout(() => {}, 1000);
                }).catch((e) => {
                    console.log('error:', e);
                })
            });
        });
    }

    render() {
        let translations = this.props.intl.messages;
        let phoneNumber = this.props.inquiryData.contact.phone;
        let countryCode = this.props.inquiryData.contact.countryCode;
        let error = this.props.inquiryData.error;

        return (
            <div className="contact-info">
              <h2 className="verification-header">{translations.verifyPhoneHeading}</h2>
                <Formik
                    initialValues={{ verificationCode: '' }}
                    validationSchema={verificationCodeValidation}
                    onSubmit={(values, { setSubmitting }) => {
                        let headers = new Headers({
                            'Content-Type': 'application/json'
                        });
                        fetch(`https://otg-privacy-api.azurewebsites.net/api/security/code/verify?phone=${countryCode}${phoneNumber}&code=${values.verificationCode}`, {
                            method: 'GET',
                            headers
                        }).then(response => {
                            if (response.status === 400) {
                                throw new Error('your error message here');
                            }
                            if (response.ok)
                                setTimeout(() => {
                                    this.props.verifiedNumberSuccess();
                                    this.props.router.navigate('/confirm');
                                }, 1000);
                        }).catch((e) => {
                            console.log('error:', e);
                            this.props.verifiedNumberError();
                            setSubmitting=false
                        })
                    }}>
                    {({
                        values,
                        touched,
                        errors,
                        handleChange,
                        handleBlur,
                        isValid,
                        isSubmitting
                    }) => (
                        <Form autoComplete="off">
                            <div className="field">
                                <label className="label" htmlFor="verificationCode">
                                    <FormattedMessage id="verificationCodeLabel" defaultMessage="Name" />
                                </label>
                                <input
                                    id="verificationCode"
                                    placeholder={translations.verificationCodePlaceholder}
                                    type="text"
                                    value={values.verificationCode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={errors.verificationCode && touched.verificationCode ? 'input error' : 'input'}
                                />
                                {error && touched.verificationCode && <div className="input-feedback"><FormattedMessage id="wrongCode" defaultMessage="Wrong code, try again" /></div>}
                            </div>

                            <a type='button' onClick={this.sendSms.bind(this)}>
                                <FormattedMessage id="sendNewCode" defaultMessage="Send a new code" />
                            </a>

                            <div className="submit-wrapper">
                                <button type="submit" disabled={isSubmitting || !isValid}>
                                    <FormattedMessage id="formSubmit" defaultMessage="Submit" />
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}

let mapStateToProps = state => ({
    inquiryData: state.inquiryData,
    error: state.inquiryData.error,
    verified: state.inquiryData.verified,
    httpError: state.httpError,
    lang: state.locale.lang
});

export default withRouter(injectIntl(compose(connect(mapStateToProps,
    {
        addContactInfo,
        verifiedNumberSuccess,
        verifiedNumberError
    }
))(VerifyPhoneNumber)));